import { SearchableSelect } from "@/components/shared/SearchableSelect";

export function MachineSelect({ assets, value, onChange, testId }) {
  return (
    <div>
      <p className="text-sm font-medium text-slate-700 mb-1.5">
        Which machine? <span className="text-red-500">*</span>
      </p>
      <SearchableSelect
        testId={testId}
        value={value}
        onValueChange={onChange}
        placeholder="Select machine"
        options={assets.map((a) => ({ value: a.asset_id, label: a.label }))}
      />
    </div>
  );
}
